<template>
  <div>
    <a
      class="module"
      :class="{ teaser : module.authority === 'teaser', 'open-module' : showSubModules }"
      @click.prevent="toggle"
    >
      <div class="icon">
        <SvgIcon
          v-if="visibleSubModules.length"
          width="0.6em"
          :data="require('@icons/streamline-icons/Outline version/52-Arrows-Diagrams/01-Arrows/arrow-down-1.svg')"
        />
      </div>
      <div class="name">{{ module.moduleName }}</div>
    </a>
    <transition
      v-if="module.authority === 'granted'"
      name="sub-modules"
    >
      <div
        v-show="showSubModules"
        class="container"
        :style="{'max-height': (module.subAuthorityModules.length * 38) + 'px'}"
      >
        <MenuSubModule
          v-for="subModule in visibleSubModules"
          :key="subModule.moduleKey"
          :sub-module="subModule"
        />
      </div>
    </transition>
  </div>
</template>

<script>
import MenuSubModule from '@/components/layout/navigation/menu/level3/MenuSubModule.vue';
import mitt from 'mitt';

export default {
  name: 'MenuModuleExpandable',
  components: { MenuSubModule },
  props: {
    module: {
      type: Object,
      default: () => {
      },
    },
    eventBus: {
      type: Object,
      default: () => mitt(),
    },
  },
  data() {
    return {
      showSubModules: false,
    };
  },
  computed: {
    visibleSubModules() {
      return this.module.subAuthorityModules
        .filter((subModule) => subModule.showInMenu)
        .filter((subModule) => subModule.authority === 'granted' || subModule.authority === 'teaser');
    },
  },
  mounted() {
    this.eventBus.on('close-all', () => {
      this.showSubModules = false;
    });

    this.eventBus.on('module-clicked', (data) => {
      this.showSubModules = (this.module.key === data.except);
    });
  },
  methods: {
    toggle() {
      if (this.module.authority !== 'teaser') {
        this.eventBus.emit('module-clicked',
          {
            except: !this.showSubModules
              ? this.module.key
              : '',
            subModules: this.module.subAuthorityModules.length,
          });

        this.$emit('add-extra-height', this.visibleSubModules.length);
      }
    },

  },
};
</script>

<style lang="scss" scoped>
  @import "style";

  div.container {
    width: 91%;
    margin-left: auto;
    margin-right: 0;
    border-left: 1px solid var(--border-color-hex);
    overflow: hidden;
  }

  .module {
    &.open-module {
      background-color: var(--menu-module-active-bg-hex);

      .icon {
        svg {
          opacity: 1;
          transform: rotate(-180deg);
        }
      }
    }
  }

  .sub-modules-enter-active {
    transition: max-height 0.3s;
  }

  .sub-modules-leave-active {
    transition: max-height 0.2s;
  }

  .sub-modules-enter,
  .sub-modules-leave-to {
    max-height: 0 !important;
  }

</style>
